import React from 'react';
import Icon from '../../../components/AppIcon';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const RevenueDistributionChart = ({ data = [], loading = false }) => {
  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-3">
          <p className="text-sm font-medium text-foreground mb-1">{payload?.[0]?.payload?.name}</p>
          <p className="text-sm text-muted-foreground">
            Clientes: <span className="font-semibold text-foreground">{payload?.[0]?.value}</span>
          </p>
          <p className="text-sm text-muted-foreground">
            Ingresos: <span className="font-semibold text-success">{formatCurrency(payload?.[0]?.payload?.revenue)}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="BarChart3" size={24} className="text-primary" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Distribución de Clientes por Ingresos
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : data?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64">
          <Icon name="BarChart" size={48} className="text-muted-foreground mb-2" />
          <p className="text-sm caption text-muted-foreground">
            No hay datos de distribución disponibles
          </p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis
              dataKey="name"
              tick={{ fill: '#6b7280', fontSize: 12 }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis tick={{ fill: '#6b7280', fontSize: 12 }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: '14px' }} />
            <Bar dataKey="count" fill="#3b82f6" name="Número de Clientes" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default RevenueDistributionChart;